import {useSuspenseQuery} from "@tanstack/react-query";
import regionList from "../../store/static_json/regionList";
import axios from "axios";
import {getTierCutAPI} from "../../store/saga/summoner";
import _ from "lodash";
import {getRegionServer} from "../../function";

const setEventName = (name) => {
    switch (name) {
        case 'たぬき忍者':
            return "TanukiNinja"
        case 'しゃるる':
            return "Syaruru"
        case 'raizin':
            return "Raizin"
        case 'jasper':
            return "Jasper"
        case 'げまげま':
            return "ROOM"
        default:
            return ""
    }
}

const useEventAPI = () => {
    const query = useSuspenseQuery({
        queryKey: ['event'],
        queryFn: async () => {
            const url = new URL(`${process.env.REACT_APP_CACHE_API}summoner/strm_pro_event`);
            const event = await axios.get(url.toString());
            // getTierCutAPI('KR'), getTierCutAPI('JP')
            const data = Object.values(event.data);


            const filterComment = data.map((item) => {
                const without = item.filter((foo) => !foo.comment)
                return without
            })
            const onlyComment = data.reduce((sum, item) => {
                const comment = item.filter((foo) => foo.comment)
                return [...sum, ...comment]
            }, [])


            const normalizeData = filterComment.reduce((sum, cur) => {
                return [...sum, ...cur]
            }, []);

            const tierCutList = normalizeData.map((item) => getRegionServer(item.platform_id));
            const uniq = _.uniq(tierCutList);
            const tierCutAll = await Promise.all(uniq.map((data) => getTierCutAPI({platform_id: data})));
            // const [event,liveInfo,scrim] = await Promise.all([
            //     axios.get(`${process.env.REACT_APP_CACHE_API}summoner/strm_pro_event`),
            //     axios.get(`${process.env.REACT_APP_CACHE_API}summoner/strm_pro_event_broadcast`),
            //     axios.get(`${process.env.REACT_APP_CACHE_API}summoner/strm_pro_win_table`)
            // ]);
            //
            //
            // const eventArray = Object.values(event.data)
            // const scrimArray = Object.values(scrim.data);
            //
            // const eventObjArray = eventArray.map((data) => {
            //     const findLeader = data.find((item) => item.hasOwnProperty('comment_jp'));
            //     const playerList = data.filter((item) => item.puu_id !== findLeader?.puu_id);
            //     return {
            //         leader: findLeader,
            //         player: playerList
            //     }
            // })
            //

            // return {
            //     eventArray: eventObjArray,
            //     liveInfo: liveInfo?.data?.broadcast_info || [],
            //     tier_off: {
            //         challenger_1st: 1000,
            //         challenger_cut_off: 1000,
            //         grandmaster_cut_off: 1000,
            //     },
            //     scrim: scrimArray
            // }

            const tier_off_map = tierCutAll.map((data, index) => {
                return {
                    ...data,
                    platform_id: tierCutList[index]
                }
            });

            const sortedEventRegionList = regionList.reduce((sum, cur) => {
                const hadName = data.some((item) => item.platform_id === cur.serverName);
                if (hadName) {
                    sum.push(cur.title);
                }
                return sum;
            }, []);

            return {
                eventRegionList: sortedEventRegionList,
                normalizeData,
                eventFilter: [],
                list: filterComment,
                commentList:onlyComment,
                tier_cut_map: tier_off_map
            }
        },
        retry: 0,
        refetchOnWindowFocus: false,
    })
    return {
        eventQuery: query,
    }
};

export default useEventAPI;